const ACCESS_NONE = 0;
const ACCESS_READ = 1;
const ACCESS_READWRITE = 2;

const memberPermissions = {
  overall: ACCESS_READ,
  general: ACCESS_READWRITE,
  members: ACCESS_NONE,
  costManagement: ACCESS_READ,
  billingHistory: ACCESS_NONE,
  workspaces: ACCESS_READWRITE,
  campaigns: ACCESS_READWRITE,
  candidates: ACCESS_READWRITE,
  candidatesActivations: ACCESS_READWRITE,
  payments: ACCESS_NONE,
};

export { memberPermissions };
